import { Form } from "../Support/Form";
import { axios } from "../Support/axios";

export class Tenant extends Form {

    constructor(data = {}) {
        super(data);

        this.data.name = null;

        this.tenant = false;
        this.tenants = false;

        this.names = false;
    }

    tenantsAvailable() {
        if (this.tenants && this.tenants.data) {
            return this.tenants.data.length > 0;
        }

        return false;
    }

    index() {
        let self = this;

        return new Promise((resolve, reject) => {
            axios.get('/api/tenant', self.data)
                .then(response => {

                    self.tenants = response.data;

                    resolve(true);
                })
                .catch(error => {
                    self.setError(error);
                    reject(error);
                });
        });
    }



    createTenant() {
        let self = this;

        self.resetFormMessages().then(result => {
            self.setFormUpdating();
        });

        return new Promise((resolve, reject) => {
            axios.post('/api/tenant', self.data)
                .then(response => {
                    self.setSuccessMessage('Tenant Created')
                    self.setFormUpdateComplete();

                    resolve(true);
                })
                .catch(error => {
                    self.setError(error);
                    reject(error);
                })
        });
    }
}
